/* ══════════════════════════════════════════════════════════════════════════
   TSC 3D CARD GALLERY — the only JavaScript in the block.

   What is deliberately NOT here: the curvature. That is a CSS view() timeline
   running on the compositor, so no scroll listener exists and nothing in this
   file runs while the rail is being scrolled or swiped. All this does is the
   pointer tilt, which only runs while a pointer is physically on one card, and
   keyboard centring.
   ══════════════════════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  /* The section tag loads this file, so two galleries on one page mean two
     <script> elements with the same src. The browser fetches it once but RUNS
     it twice, which would double every listener. */
  if (window.__tscCards3d) return;
  window.__tscCards3d = true;

  const rails = document.querySelectorAll('.c3d-rail');
  if (!rails.length) return;

  const still = matchMedia('(prefers-reduced-motion: reduce)');

  /* Writes are batched into one animation frame. Reading getBoundingClientRect
     in a pointermove handler and writing a style immediately after is a forced
     synchronous layout on every single move event; on a rail of eight cards
     that was measurable. */
  let queued = null;
  const write = (fn) => {
    queued = fn;
    if (write.raf) return;
    write.raf = requestAnimationFrame(() => {
      write.raf = 0;
      const f = queued; queued = null;
      if (f) f();
    });
  };

  const MAX = 9;  /* degrees. Past about 10 the card stops looking like it is
                     being handled and starts looking like it is falling over. */

  rails.forEach((rail) => {
    rail.querySelectorAll('.c3d-card').forEach((card) => {
      const tilt = card.querySelector('.c3d-tilt');
      const face = card.querySelector('.c3d-face');
      if (!tilt || !face) return;

      const move = (e) => {
        if (still.matches) return;
        const r = card.getBoundingClientRect();
        if (!r.width || !r.height) return;
        /* -0.5 … 0.5 from the card's own centre */
        const px = (e.clientX - r.left) / r.width  - 0.5;
        const py = (e.clientY - r.top)  / r.height - 0.5;
        write(() => {
          /* Plain numbers here, with the unit applied in CSS. Interpolating a
             percentage into a rotate() is invalid -- a percentage is not an
             <angle> -- and the whole transform is then dropped silently, which
             is a bug this theme has already shipped once. */
          tilt.style.setProperty('--ry', (px *  MAX * 2).toFixed(2) + 'deg');
          tilt.style.setProperty('--rx', (py * -MAX * 2).toFixed(2) + 'deg');
          /* The glare and the foil follow the pointer across the face. */
          face.style.setProperty('--mx', ((px + 0.5) * 100).toFixed(1) + '%');
          face.style.setProperty('--my', ((py + 0.5) * 100).toFixed(1) + '%');
        });
      };

      const rest = () => {
        write(() => {
          tilt.style.setProperty('--rx', '0deg');
          tilt.style.setProperty('--ry', '0deg');
          face.style.setProperty('--mx', '50%');
          face.style.setProperty('--my', '42%');
        });
        card.classList.remove('is-live');
      };

      /* pointerenter rather than pointerover: pointerover fires again for every
         child element crossed, and the card has five of them. */
      card.addEventListener('pointerenter', () => {
        if (!still.matches) card.classList.add('is-live');
      });
      card.addEventListener('pointermove', move, { passive: true });
      card.addEventListener('pointerleave', rest);
      card.addEventListener('pointercancel', rest);
      /* A tap must not leave a phone card frozen mid-tilt with no pointer to
         un-tilt it. */
      card.addEventListener('pointerup', rest);
      card.addEventListener('blur', rest, true);
    });

    /* KEYBOARD.
       Tabbing moves focus through cards that may be turned away at the edge of
       the shelf. The browser will scroll a focused element into view, but into
       *view* means the nearest edge -- which is exactly where the curve turns a
       card furthest away. Centring it instead means the card a keyboard user is
       on is the card facing them, which is the same guarantee the mouse gets. */
    rail.addEventListener('focusin', (e) => {
      const card = e.target.closest ? e.target.closest('.c3d-card') : null;
      if (!card) return;
      card.scrollIntoView({
        behavior: still.matches ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    });
  });
})();
